/* ============
 * Vue i18n
 * ============
 *
 * Internationalization plugin of Vue.js.
 *
 * https://kazupon.github.io/vue-i18n/
 */

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from '@/app/locale'
import store from '@/app/store'

// element-ui internationalization
import enLocale from 'element-ui/lib/locale/lang/en'
import ElementLocale from 'element-ui/lib/locale'

messages.en = Object.assign(messages.en, enLocale)

Vue.use(VueI18n)

ElementLocale.i18n((key, value) => i18n.t(key, value))

export const i18n = new VueI18n({
  locale: store.state.locale.current,
  fallbackLocale: store.state.locale.current,
  messages
})

export default {
  i18n
}



// WEBPACK FOOTER //
// ./src/app/plugins/vue-i18n.js